var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row-grid block__mod",
      class: { left: _vm.position, mobile_b: _vm.mobile }
    },
    [
      !_vm.mobile
        ? _c(
            "div",
            { staticClass: "col-md-6 item img-item" },
            [
              !_vm.linkRef && _vm.link !== "#"
                ? _c(
                    "nuxt-link",
                    { staticClass: "content", attrs: { to: _vm.link } },
                    [
                      _vm.img
                        ? _c("div", {
                            staticClass: "img",
                            style: "background-image: url(" + _vm.img + ");"
                          })
                        : _c("div", { staticClass: "img" })
                    ]
                  )
                : _vm._e(),
              _vm.linkRef
                ? _c(
                    "a",
                    { staticClass: "content", attrs: { href: _vm.linkRef } },
                    [
                      _vm.img
                        ? _c("div", {
                            staticClass: "img",
                            style: "background-image: url(" + _vm.img + ");"
                          })
                        : _c("div", { staticClass: "img" })
                    ]
                  )
                : _vm._e(),
              _vm.link === "#"
                ? _c(
                    "div",
                    { staticClass: "content", attrs: { to: _vm.link } },
                    [
                      _vm.img
                        ? _c("div", {
                            staticClass: "img",
                            style: "background-image: url(" + _vm.img + ");"
                          })
                        : _c("div", { staticClass: "img" })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "col-md-6 item" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _c("div", { staticClass: "description" }, [_vm._t("default")], 2),
          _vm.buttonShow
            ? _c(
                "div",
                { staticClass: "buttons" },
                [
                  !_vm.linkRef
                    ? _c(
                        "nuxt-link",
                        {
                          staticClass: "btn solid--green large",
                          attrs: { to: _vm.link }
                        },
                        [_vm._v(_vm._s(_vm.buttonText))]
                      )
                    : _vm._e(),
                  _vm.linkRef
                    ? _c(
                        "a",
                        {
                          staticClass: "btn solid--green large",
                          attrs: { href: _vm.linkRef, target: "_blank" }
                        },
                        [_vm._v(_vm._s(_vm.buttonText))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d6472e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d6472e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/cards/CardBox.vue
// module id = 40Vb
// module chunks = 10 11 12 13 14 17 21 22 23 25 26